/**
 * CMCD session header name.
 *
 *
 * @beta
 */
export const CMCD_SESSION = 'CMCD-Session'
